import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import withStyles from "@material-ui/styles/withStyles";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

import {
  PageHeader,
  PageFooter,
  crudGetOne,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  BackButton,
  RestMethods,
  FETCH_START,
  FETCH_END
} from "jazasoft";

import Table from "jazasoft/lib/mui/components/Table";

import CardHeader from "../../../components/CardHeader";
import { dataProvider } from "../../../App";
import handleError from "../../../utils/handleError";
import { partialData, syntaxHighlight } from "../../../utils/helpers";

const fieldOptions = sm => ({
  xs: 12,
  sm
});

const columns = [
  { dataKey: "time", title: "Time" },
  { dataKey: "createdBy", title: "User" },
  { dataKey: "extraInfo", title: "Part" },
  { dataKey: "event", title: "Event" },
  { dataKey: "dataEl", title: "Data" }
];

const styles = theme => ({
  root: {},
  container: {
    margin: theme.spacing(3)
  },
  marginVertical: {
    margin: "1.5em 0"
  }
});

class CostingView extends Component {
  state = {
    logs: [],
    dialogActive: false,
    logId: null
  };

  componentDidMount() {
    this.fetchCosting();
    this.fetchLogs();
  }

  fetchCosting = (id = this.props.id) => {
    if (!id) return;
    this.props.dispatch(crudGetOne("costings", id));
  };

  fetchLogs = () => {
    const options = {
      url: `estLogs`,
      method: "get",
      params: {
        search: `costingId==${this.props.id}`
      }
    };
    this.props.dispatch({ type: FETCH_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          this.setState({ logs: response.data.content });
        }
        this.props.dispatch({ type: FETCH_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
      });
  };

  onViewClick = logId => e => {
    e.preventDefault();
    this.setState({ dialogActive: true, logId });
  };

  render() {
    const { classes, record = {} } = this.props;
    const { dialogActive, logId, logs } = this.state;
    const rows = this.state.logs
      .sort((a, b) => b.createdAt - a.createdAt)
      .map(e => ({
        ...e,
        time: moment(e.createdAt).format("DD MMM, YY hh:mm a"),
        dataEl: e.diff ? partialData(e.diff, this.onViewClick(e.id)) : partialData(e.data, this.onViewClick(e.id)),
        fabric: e.itemCode ? `${e.itemCode}, ${e.colors}` : "-"
      }));

    const log = logs.find(e => e.id === logId);
    let dataStr;
    if (log) {
      if (log.diff) {
        dataStr = log.diff;
      } else {
        dataStr = syntaxHighlight(JSON.stringify(JSON.parse(log.data), null, 4));
      }
    }

    return (
      <div>
        <PageHeader title="Costing History" />

        {dialogActive && logId && (
          <Dialog
            open={dialogActive}
            fullWidth={true}
            maxWidth="md"
            onClose={() => this.setState({ dialogActive: false, logId: null })}
          >
            <DialogContent style={{ padding: "2em" }}>
              <span style={{ whiteSpace: "pre", fontSize: 14 }} dangerouslySetInnerHTML={{ __html: dataStr }} />
            </DialogContent>
          </Dialog>
        )}

        {record && Object.keys(record).length > 0 && (
          <div className={classes.container}>
            <Card className={classes.marginVertical}>
              <CardHeader title="Costing Details" />
              <Divider />
              <CardContent>
                <SimpleShowLayout record={record} footer={false}>
                  <TextField label="Costing Id" source="cstId" {...fieldOptions(3)} />
                  <ReferenceField
                    source="checklistId"
                    reference="cuChecklists"
                    linkType={(record = {}) => `/estimation/cuChecklists/${record.checklistId}/view`}
                    {...fieldOptions(3)}
                  >
                    <TextField source="checkListId" />
                  </ReferenceField>
                  <TextField source="product" {...fieldOptions(3)} />
                  <TextField source="fit" {...fieldOptions(3)} />
                  <TextField label="Customer" source="customer.name" {...fieldOptions(3)} />
                  <TextField label="Season" source="season.name" {...fieldOptions(3)} />
                  <TextField source="colors" xs={12} sm={6} fullWidth />
                  <TextField source="style" xs={12} fullWidth />
                </SimpleShowLayout>
              </CardContent>
            </Card>

            <Card className={classes.marginVertical}>
              <CardHeader title="History" />
              <Divider />
              <CardContent style={{ padding: 0 }}>
                <Table columns={columns} rows={rows} />
              </CardContent>
            </Card>
          </div>
        )}

        <PageFooter style={{ marginLeft: 24 }}>
          <BackButton variant="contained" color="default" />
        </PageFooter>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const resourceState = state.jazasoft.resources["costings"];
  const id = props.match.params.id;
  return {
    id,
    record: resourceState && resourceState.data[id],
    isLoading: state.jazasoft.loading > 0,
    version: state.jazasoft.ui.viewVersion
  };
};

export default connect(mapStateToProps)(withStyles(styles)(CostingView));
